<script lang="ts">
  import Lazy from 'svelte-lazy';
  import { PUBLIC_BIXOTO_MEDIA } from '$env/static/public';
  import { addToCart } from '$lib/js/cart';
  import { getProductRegularPriceWithTax, getProductSpecialPriceWithTax, is_set_object } from '$lib/js/helpers';
  import { t } from 'svelte-i18n-lingui';
  import { goto } from '$app/navigation';
  import { page } from '$app/stores'
  import type { FullProduct } from "$lib/js/elasticsearch/types";
	import { getContextScope } from '$lib/js/helpers/i18n'
	import { getFormattedPrice, getProductRetailPriceWithTax } from '$lib/js/helpers/prices'

  export let product: FullProduct
  export let uClass: 'featured-brand' | '' = ''
  export let color: string = ""

	const scope = getContextScope()

  let color_sec = "#000000"

  let special_price: number,
    retail_price: number,
    regular_price: number;

  if(is_set_object(product)) {
    special_price = getProductSpecialPriceWithTax(product)
    regular_price = getProductRegularPriceWithTax(product)
    retail_price = getProductRetailPriceWithTax(product)
  }

  async function addItemToCart(product) {
    if(product.type_id === 'simple' && product.stock.source_quantity > 0) {
      product.cart_qty = 1;
      await addToCart(product)
    } else {
      await goto(`/${scope}/p/${product.url_key}`)
    }
  }

  let universe_info: any = {}

  $: if($page.route.id === "/[lang]/blog/[post_url]" && $page.data.page_data?.universe_name && color === "") {
    universe_info = $page.data.universes_menu.universes.filter((el) => el.name === $page.data.page_data?.universe_name)[0]
    color = universe_info?.color
    color_sec = universe_info?.color_sec
  }
</script>


{#if is_set_object(product)}
  <div class="offer-card {uClass}" style="background-color: {color}">
    <a href="/{scope}/p/{product.url_key}" class="offer-card__img">
      <Lazy height={220}>
        {#if uClass === 'featured-brand' && product.resized_image}
          <img src="{PUBLIC_BIXOTO_MEDIA}{product.resized_image?.path}"
               height="400"
               width="400"
               alt="{product.name}" title="{product.name}">
        {:else if product.resized_small_image}
          <img src="{PUBLIC_BIXOTO_MEDIA}{product.resized_small_image?.path}"
               height="220"
               width="220"
               alt="{product.name}" title="{product.name}">
        {:else if product.image && product.image !== 'no_selection'}
          <img src="{PUBLIC_BIXOTO_MEDIA}{product.image}" alt="{product.name}" title="{product.name}">
        {/if}
      </Lazy>
    </a>

    <div class="offer-card__content">
      <div class="offer-card__text">
        <a href="/{scope}/p/{product.url_key}">
          <h2 style="color: {color_sec}">{product.name}</h2>
        </a>

        {#if special_price && special_price < regular_price}
          <p class="recommended">{$t`Common price:`} <span>{getFormattedPrice(regular_price)}€</span></p>

          <h2 class="special-price">
            <span class="total">{getFormattedPrice(special_price)}€</span>
            <span class="savings">{$t`Save ${getFormattedPrice(regular_price - special_price)} (${(100 - (special_price * 100 / regular_price)).toFixed(2)}%)`}</span>
          </h2>
        {:else if regular_price < retail_price}
          <p class="recommended">{$t`Recommended price:`} <span>{getFormattedPrice(retail_price)}€</span></p>

          <h2 class="special-price">
            <span class="total">{getFormattedPrice(regular_price)}€</span>
            <span class="savings">{$t`Save ${getFormattedPrice(retail_price - regular_price)} (${(100 - (regular_price * 100 / retail_price)).toFixed(2)}%)`}</span>
          </h2>
        {:else}
          <h2 class="special-price">
            <span class="total">{getFormattedPrice(regular_price)}€</span>
          </h2>
        {/if}
      </div>

      <button class="u-btn" on:click="{()=> addItemToCart(product)}">
        <span class="icon icon-add-to-cart"></span>
        {$t`Add to cart`}
      </button>
    </div>
  </div>
{/if}


<style lang="scss">
  .offer-card {
    padding: 20px;
    background: #F6F6F6;

    @media (min-width: 560px) {
      display: flex;
    }

    @media (min-width: 769px) {
      display: block;
    }

    @media (min-width: 1201px) {
      display: flex;
    }

    img {
      width: calc(100% - 20px);
      height: calc(100% - 20px);
      padding: 10px;
      background: white;
      object-fit: contain;
      transition: all linear 0.125s;

      &:hover {
        @media (min-width: 769px) {
          transform: scale(1.05);
        }
      }
    }

    &__img {
      display: block;
      overflow: hidden;
      width: 100%;
      height: 100%;
      margin-bottom: 15px;
      flex-grow: 1;

      @media (min-width: 560px) {
        margin-bottom: 0;
        width: 220px;
        height: 220px;
      }

      @media (min-width: 769px) {
        margin-bottom: 15px;
        width: 100%;
        height: 100%;
      }

      @media (min-width: 1201px) {
        margin-bottom: 0;
        width: 220px;
        height: 220px;
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      @media (min-width: 560px) {
        padding-left: 25px;
        width: calc(100% - 245px);
      }

      @media (min-width: 769px) {
        padding-left: 0;
        width: 100%;
      }

      @media (min-width: 1201px) {
        padding-left: 25px;
        width: calc(100% - 245px);
      }

      h2 {
        font-size: 22px;
        transition: all linear 0.125s;
      }

      .recommended {
        span {
          text-decoration: line-through;
        }
      }

      .special-price {
        font-size: 36px;
        color: var(--main);
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        span.total {
          margin-right: 10px;
        }

        span.savings {
          font-size: 14px;
          padding: 6px 10px;
          display: inline-block;
          border: 1px solid var(--main);
        }
      }
    }

    &.featured-brand {
      background: rgba(246, 246, 246, 0.4);

      .offer-card {
        &__img {
          @media (min-width: 1201px) {
            margin-bottom: 0;
            width: 400px;
            height: 400px;
          }

          @media (min-width: 1500px) {
            width: 500px;
            height: 500px;
          }
        }

        &__content {
          margin-top: 18%;

          @media (min-width: 1201px) {
            padding-left: 25px;
            width: calc(100% - 425px);
          }

          @media (min-width: 1500px) {
            width: calc(100% - 525px);
          }
        }

        &__text {
          margin-bottom: 15px;
        }
      }
    }
  }
</style>
